import React from 'react'
import SVG from 'react-inlinesvg'

//icons
import venueUrl from './icons/venue.svg'
import clockUrl from './icons/clock.svg'
import pinUrl from './icons/pin.svg'
import checkUrl from './icons/check.svg'
import cloudUploadUrl from './icons/cloud_upload.svg'
import removeIconUrl from './icons/remove-icon.svg'
import closeXUrl from './icons/close-x.svg'
import greenTickUrl from './icons/green-check.svg'
import circleTickUrl from './icons/navy_tick.svg'
import errorUrl from './icons/error.svg'
import warningUrl from './icons/warning.svg'
import warningCircleUrl from './icons/warning-circle.svg'
import warningTriangle from './icons/warning_triangle.svg'
import publicUrl from './icons/public.svg'
import moreHorizUrl from './icons/more_horiz.svg'
import thumbUpUrl from './icons/thumb_up.svg'
import chatBubbleOutlineUrl from './icons/chat_bubble_outline.svg'
import chatBubbleInstaUrl from './icons/chat_bubble_insta.svg'
import facebookShareUrl from './icons/facebook_share.svg'
import cancelledUrl from './icons/cancelled.svg'
import cancelledWhiteUrl from './icons/cancelled_white.svg'
import heartUrl from './icons/heart.svg'
import sendUrl from './icons/send.svg'
import arrowForwardUrl from './icons/arrow_forward_ios.svg'
import bookmarkOutlineUrl from './icons/bookmark_outline.svg'
import cameraUrl from './icons/camera.svg'
import cancelUrl from './icons/cancelled.svg'
import searchUrl from './icons/search.svg'
import searchSyncNavyUrl from './icons/search-sync-navy.svg'
import syncUrl from './icons/sync.svg'
import calenderUrl from './icons/calender.svg'
import arrowDownUrl from './icons/arrow-down.svg'
import arrowDownThinUrl from './icons/arrow-down-thin.svg'
import arrowDownThreeUrl from './icons/arrow-down-three.svg'
import lightBulbOutline from './icons/lightbulb_outline.svg'
import lightBulb from './icons/lightbulb.svg'
import impressionsUrl from './icons/visibility.png'
import googleGUrl from './icons/google-g.png'
import touchUrl from './icons/touch.png'
import walletUrl from './icons/wallet.svg'
import connectedUrl from './icons/connected.svg'
import alarmUrl from './icons/alarm.svg'
import mergRedUrl from './icons/merge-red.svg'
import editUrl from './icons/edit.svg'
import eventGreyUrl from './icons/event_grey.svg'
import eventUrl from './icons/event.svg'
import envelopeUrl from './icons/envelop.svg'
import userNavyUrl from './icons/user-navy.svg'
import worldUrl from './icons/world.svg'
import leftArrowUrl from './icons/leftArrow.svg'
import rightArrowUrl from './icons/rightArrow.svg'
import leftArrowCircleUrl from './icons/arrow-left-circle.svg'
import rightArrowCircleUrl from './icons/arrow-right-circle.svg'
import tickWrappedUrl from './icons/green_tick_wrapped.svg'
import descriptionUrl from './icons/description.svg'
import playlistUrl from './icons/playlist.svg'
import campaignUrl from './icons/campaign.svg'
import exportUrl from './icons/export.svg'
import importUrl from './icons/import.svg'
import donutUrl from './icons/donut.svg'
import binUrl from './icons/bin.svg'
import minusCircleUrl from './icons/minus-circle.svg'
import categoryUrl from './icons/category.svg'
import dotsMenuUrl from './icons/dots-menu.svg'
import chevronUrl from './icons/chevron.svg'
import starUrl from './icons/star.svg'
import startFilledUrl from './icons/star-filled.svg'
import drawerUrl from './icons/drawer-red.svg'
import cashUrl from './icons/cash.svg'
import copyUrl from './icons/copy_icon.svg'
import phiUrl from './icons/phi.svg'
import sigmaUrl from './icons/sigma.svg'
import notAllowedUrl from './icons/not_allowed.svg'
import reachUrl from './icons/reach.svg'
import ctrUrl from './icons/ctr.svg'
import trashIconUrl from './icons/trash-icon.svg'
import editButtonIconUrl from './icons/edit-button.svg'
import priceSensitivityUrl from './icons/price-sensitivity.svg'
import itemsIconUrl from './icons/items.svg'
import calendarIconUrl from './icons/calendar.svg'
import linkUrl from './icons/link.svg'
import carouselAdEmptyUrl from './icons/empty-carousel.svg'
import plusIconUrl from './icons/plus-icon.svg'
import leftArrowThickUrl from './icons/arrow-left-thick.svg'
import rightArrowThickUrl from './icons/arrow-right-thick.svg'
import rightArrowThinUrl from './icons/arrow-right-thin.svg'
import leftArrowThinUrl from './icons/arrow-left-thin.svg'
import eyeUrl from './icons/eye.svg'
import eyeOffUrl from './icons/eye-off.svg'
import undoIconUrl from './icons/undo.svg'
import uploadIconUrl from './icons/upload.svg'
import mediaIconUrl from './icons/image.svg'
import crownIconUrl from './icons/crown.svg'
import layersIconUrl from './icons/layers.svg'
import expandIconUrl from './icons/expand.svg'
import headingIconUrl from './icons/heading.svg'
import heading1 from './icons/heading-1.svg'
import heading2 from './icons/heading-2.svg'
import heading3 from './icons/heading-3.svg'
import heading4 from './icons/heading-4.svg'
import heading5 from './icons/heading-5.svg'
import redoIconUrl from './icons/redo.svg'
import plusImageIconUrl from './icons/image-plus.svg'
import NoImagesIconUrl from './icons/image-off.svg'
import PenToolIconUrl from './icons/pen-tool.svg'
import ImagesIconUrl from './icons/images.svg'
import forwardUrl from './icons/forward.svg'
import linkChainUrl from './icons/link-chain.svg'
import fdPublishedUrl from './icons/fd-published.svg'
import checkCheckIconUrl from './icons/check-check.svg'
import circlePlayIconUrl from './icons/circle-play.svg'
import badgeInfoUrl from './icons/badge-info.svg'
import triangleAlertUrl from './icons/triangle-alert.svg'
import panelOpenUrl from './icons/panel-open.svg'
import panelCloseUrl from './icons/panel-close.svg'
import circlePlusUrl from './icons/circle-plus.svg'
import chevronsUpDownUrl from './icons/chevrons-up-down.svg'
import walletMinimalIconUrl from './icons/wallet-minimal.svg'
import circleXIconUrl from './icons/circle-x.svg'
import arrowUpRightUrl from './icons/arrow-up-right.svg'
import moreVertIconUrl from './icons/ellipsis-vertical.svg'
import shareIconUrl from './icons/share.svg'
import shareArrowUpUrl from './icons/share-arrow-up.svg'
import youtubePlayIconUrl from './icons/youtube-play.svg'

//logos
import googleLogoUrl from './icons/google-logo.svg'

//navbar
import demandPredictionUrl from './navbar/app_demandprediction.svg'
import contentExpertUrl from './navbar/app_contentexpert.svg'
import sponsorshipActivationUrl from './navbar/app_sponsorshipactivation.svg'
import salesBoostUrl from './navbar/app_salesboost.svg'
import backhaulUrl from './navbar/app_backhaul.png'
import backhaulSvgUrl from './navbar/app_backhaul.svg'
import lookoutUrl from './navbar/app_lookout.png'
import lookoutSvgUrl from './navbar/app_lookout.svg'
import sentinelUrl from './navbar/app_sentinel.png'
import waveUrl from './navbar/app_wave.png'
import waveSvgUrl from './navbar/app_wave.svg'
import uploadFilesUrl from './navbar/app_uploadfiles.svg'
import settingsUrl from './navbar/app_settings.svg'
import logoutUrl from './navbar/app_logout.svg'
import houseIconUrl from './navbar/app_house.svg'
import fileUploadIconUrl from './navbar/app_file-up.svg'
import bellRingIconUrl from './navbar/app_bell-ring.svg'
import messageCircleIconUrl from './navbar/app_message-circle.svg'
import mailIconUrl from './icons/mail.svg'

//logos
import expandedLogoUrl from './logos/logo-lowercase-white.svg'
import logoWhiteUrl from './logos/app-icon-white.svg'
import logoTextUrl from './logos/logo-text.svg'

function withSvg(src) {
  return function WithSvg(props) {
    return <SVG {...props} src={src} />
  }
}

//icons
export const VenueIcon = withSvg(venueUrl)
export const ClockIcon = withSvg(clockUrl)
export const PinIcon = withSvg(pinUrl)
export const CheckIcon = withSvg(checkUrl)
export const CloudUpload = withSvg(cloudUploadUrl)
export const RemoveIcon = withSvg(removeIconUrl)
export const CloseXIcon = withSvg(closeXUrl)
export const ErrorIcon = withSvg(errorUrl)
export const CircleTickIcon = withSvg(circleTickUrl)
export const GreenTickIcon = withSvg(greenTickUrl)
export const WarningIcon = withSvg(warningUrl)
export const WarningCircleIcon = withSvg(warningCircleUrl)
export const WarningTriangleIcon = withSvg(warningTriangle)
export const PublicIcon = withSvg(publicUrl)
export const MoreHorizIcon = withSvg(moreHorizUrl)
export const ThumbUpIcon = withSvg(thumbUpUrl)
export const ChatBubbleOutlineIcon = withSvg(chatBubbleOutlineUrl)
export const ChatBubbleInstaIcon = withSvg(chatBubbleInstaUrl)
export const FacebookShareIcon = withSvg(facebookShareUrl)
export const CancelledIcon = withSvg(cancelledUrl)
export const CancelledWhiteIcon = withSvg(cancelledWhiteUrl)
export const HeartIcon = withSvg(heartUrl)
export const SendIcon = withSvg(sendUrl)
export const ArrowForwardIcon = withSvg(arrowForwardUrl)
export const BookmarkOutlineIcon = withSvg(bookmarkOutlineUrl)
export const CameraIcon = withSvg(cameraUrl)
export const CancelIcon = withSvg(cancelUrl)
export const SearchSyncNavyIcon = withSvg(searchSyncNavyUrl)
export const SyncIcon = withSvg(syncUrl)
export const SearchIcon = withSvg(searchUrl)
export const CalenderIcon = withSvg(calenderUrl)
export const ArrowDownIcon = withSvg(arrowDownUrl)
export const ArrowDownThinIcon = withSvg(arrowDownThinUrl)
export const ArrowDownThreeIcon = withSvg(arrowDownThreeUrl)
export const LightBulbOutlineIcon = withSvg(lightBulbOutline)
export const LightBulbIcon = withSvg(lightBulb)
export const WalletIcon = withSvg(walletUrl)
export const ConnectedIcon = withSvg(connectedUrl)
export const EditIcon = withSvg(editUrl)
export const EventGreyIcon = withSvg(eventGreyUrl)
export const EventIcon = withSvg(eventUrl)
export const AlarmIcon = withSvg(alarmUrl)
export const MergeRedIcon = withSvg(mergRedUrl)
export const EnvelopeIcon = withSvg(envelopeUrl)
export const UserNavyIcon = withSvg(userNavyUrl)
export const WorldIcon = withSvg(worldUrl)
export const LeftArrowIcon = withSvg(leftArrowUrl)
export const RightArrowIcon = withSvg(rightArrowUrl)
export const LeftArrowCircleIcon = withSvg(leftArrowCircleUrl)
export const RightArrowCircleIcon = withSvg(rightArrowCircleUrl)
export const TickWrappedIcon = withSvg(tickWrappedUrl)
export const DescriptionIcon = withSvg(descriptionUrl)
export const PlaylistIcon = withSvg(playlistUrl)
export const CampaignIcon = withSvg(campaignUrl)
export const ExportIcon = withSvg(exportUrl)
export const ImportIcon = withSvg(importUrl)
export const DonutIcon = withSvg(donutUrl)
export const MinusCircleIcon = withSvg(minusCircleUrl)
export const ImpressionsImg = impressionsUrl
export const GoogleGImg = googleGUrl
export const TouchImg = touchUrl
export const BinIcon = withSvg(binUrl)
export const CategoryIcon = withSvg(categoryUrl)
export const DotsMenuIcon = withSvg(dotsMenuUrl)
export const ChevronIcon = withSvg(chevronUrl)
export const DrawerIcon = withSvg(drawerUrl)
export const CashIcon = withSvg(cashUrl)
export const CopyIcon = withSvg(copyUrl)
export const PhiIcon = withSvg(phiUrl)
export const SigmaIcon = withSvg(sigmaUrl)
export const NotAllowedIcon = withSvg(notAllowedUrl)
export const ReachIcon = withSvg(reachUrl)
export const CTRIcon = withSvg(ctrUrl)
export const TrashIcon = withSvg(trashIconUrl)
export const EditButtonIcon = withSvg(editButtonIconUrl)
export const PriceSensitivityIcon = withSvg(priceSensitivityUrl)
export const ItemsIcon = withSvg(itemsIconUrl)
export const CalendarIcon = withSvg(calendarIconUrl)
export const LinkIcon = withSvg(linkUrl)
export const CarouselAdEmptyIcon = withSvg(carouselAdEmptyUrl)
export const PlusIcon = withSvg(plusIconUrl)
export const LeftArrowIconThick = withSvg(leftArrowThickUrl)
export const RightArrowIconThick = withSvg(rightArrowThickUrl)
export const RightArrowThinIcon = withSvg(rightArrowThinUrl)
export const LeftArrowThinIcon = withSvg(leftArrowThinUrl)
export const EyeIcon = withSvg(eyeUrl)
export const EyeOffIcon = withSvg(eyeOffUrl)
export const UndoIcon = withSvg(undoIconUrl)
export const UploadIcon = withSvg(uploadIconUrl)
export const MediaIcon = withSvg(mediaIconUrl)
export const CrownIcon = withSvg(crownIconUrl)
export const LayersIcon = withSvg(layersIconUrl)
export const ExpandIcon = withSvg(expandIconUrl)
export const HeadingIcon = withSvg(headingIconUrl)
export const Heading1Icon = withSvg(heading1)
export const Heading2Icon = withSvg(heading2)
export const Heading3Icon = withSvg(heading3)
export const Heading4Icon = withSvg(heading4)
export const Heading5Icon = withSvg(heading5)
export const RedoIcon = withSvg(redoIconUrl)
export const PlusImageIcon = withSvg(plusImageIconUrl)
export const NoImagesIcon = withSvg(NoImagesIconUrl)
export const PenToolIcon = withSvg(PenToolIconUrl)
export const ImagesIcon = withSvg(ImagesIconUrl)
export const ForwardIcon = withSvg(forwardUrl)
export const LinkChainIcon = withSvg(linkChainUrl)
export const FdPublishedIcon = withSvg(fdPublishedUrl)
export const CheckCheckIcon = withSvg(checkCheckIconUrl)
export const CirclePlayIcon = withSvg(circlePlayIconUrl)
export const BadgeInfoIcon = withSvg(badgeInfoUrl)
export const TriangleAlertIcon = withSvg(triangleAlertUrl)
export const PanelOpenIcon = withSvg(panelOpenUrl)
export const PanelCloseIcon = withSvg(panelCloseUrl)
export const CirclePlusIcon = withSvg(circlePlusUrl)
export const ChevronsUpDownIcon = withSvg(chevronsUpDownUrl)
export const WalletMinimalIcon = withSvg(walletMinimalIconUrl)
export const CircleXIcon = withSvg(circleXIconUrl)
export const ArrowUpRightIcon = withSvg(arrowUpRightUrl)
export const MailIcon = withSvg(mailIconUrl)
export const MoreVertIcon = withSvg(moreVertIconUrl)
export const ShareIcon = withSvg(shareIconUrl)
export const ShareArrowUpIcon = withSvg(shareArrowUpUrl)
export const YoutubePlayIcon = withSvg(youtubePlayIconUrl)

//logos
export const GoogleLogo = withSvg(googleLogoUrl)

//navbar
export const DemandPredictionIcon = withSvg(demandPredictionUrl)
export const ContentExpertIcon = withSvg(contentExpertUrl)
export const sponsorshipActivationIcon = withSvg(sponsorshipActivationUrl)
export const SalesBoostIcon = withSvg(salesBoostUrl)
export const BackhaulIcon = withSvg(backhaulUrl)
export const LookoutIcon = withSvg(lookoutUrl)
export const WaveIcon = withSvg(waveUrl)
export const BackhaulSVGIcon = withSvg(backhaulSvgUrl)
export const LookoutSVGIcon = withSvg(lookoutSvgUrl)
export const WaveSVGIcon = withSvg(waveSvgUrl)
export const UploadFilesIcon = withSvg(uploadFilesUrl)
export const SettingsIcon = withSvg(settingsUrl)
export const LogoutIcon = withSvg(logoutUrl)
export const SentinelIcon = sentinelUrl
export const StarIcon = withSvg(starUrl)
export const StarFilledIcon = withSvg(startFilledUrl)
export const HouseIcon = withSvg(houseIconUrl)
export const FileUploadIcon = withSvg(fileUploadIconUrl)
export const BellRingIcon = withSvg(bellRingIconUrl)
export const MessageCircleIcon = withSvg(messageCircleIconUrl)

//logos
export const ExpandedLogoWhiteIcon = withSvg(expandedLogoUrl)
export const LogoWhiteIcon = withSvg(logoWhiteUrl)
export const LogoTextIcon = withSvg(logoTextUrl)
export { sentinelUrl, waveUrl, lookoutUrl, backhaulUrl }
